"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoastalErosion$ = exports.CoastalErosion$outboundSchema = exports.CoastalErosion$inboundSchema = void 0;
exports.coastalErosionToJSON = coastalErosionToJSON;
exports.coastalErosionFromJSON = coastalErosionFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const coastalerosionplan_js_1 = require("./coastalerosionplan.js");
/** @internal */
exports.CoastalErosion$inboundSchema = z.object({
    can_have_erosion_plan: z.boolean(),
    plans: z.nullable(z.array(coastalerosionplan_js_1.CoastalErosionPlan$inboundSchema)),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "can_have_erosion_plan": "canHaveErosionPlan",
    });
});
/** @internal */
exports.CoastalErosion$outboundSchema = z.object({
    canHaveErosionPlan: z.boolean(),
    plans: z.nullable(z.array(coastalerosionplan_js_1.CoastalErosionPlan$outboundSchema)),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        canHaveErosionPlan: "can_have_erosion_plan",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var CoastalErosion$;
(function (CoastalErosion$) {
    /** @deprecated use `CoastalErosion$inboundSchema` instead. */
    CoastalErosion$.inboundSchema = exports.CoastalErosion$inboundSchema;
    /** @deprecated use `CoastalErosion$outboundSchema` instead. */
    CoastalErosion$.outboundSchema = exports.CoastalErosion$outboundSchema;
})(CoastalErosion$ || (exports.CoastalErosion$ = CoastalErosion$ = {}));
function coastalErosionToJSON(coastalErosion) {
    return JSON.stringify(exports.CoastalErosion$outboundSchema.parse(coastalErosion));
}
function coastalErosionFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.CoastalErosion$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'CoastalErosion' from JSON`);
}
//# sourceMappingURL=coastalerosion.js.map